import { object, string } from 'yup';

export interface LoginPinForm {
  pin: string;
};

export const initialValues: LoginPinForm = {
  pin: '',
};

export const validationSchema = object().shape({
  pin: string()
    .min(5)
    .max(15)
    .matches(/^\d{1,15}$/, 'validation_only_numbers')
    .nullable().required('validation_required'),
});

